
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { throwError } from 'rxjs';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { HttpClientService } from 'lib/ng2-sapmp/src/providers';
import { UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { HeaderService } from 'app/pages';


@Injectable()
export class GroupingDevicesService {

  public emmProductCode: any;
  public mdmProductName: any;
  public productDetails: any;
  public ztpAccID: any;
  urlSignUp: any;

  constructor(private http: HttpClient,
    private httpClientService: HttpClientService,
    private datePipe: DatePipe,
    private utilityService: UtilityService,
    private adobeAnalyticsService: AdobeAnalyticsService) { }

  get_headers() {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    console.log("---header--", headers)
    return headers;
  }

  submitGroupData(data: any){
    var url = this.utilityService.getEnvConfig().submitGroup
    return this.httpClientService.post(url, data, this.get_headers())
    .pipe(
      map((test: HttpResponse<any>) => {
       if (sessionStorage.getItem('sapmp_jwtToken') != null) {
         // refreshes token for logged in scenario upon page load
         this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
       }
       return test.body;
     }),
      catchError( this.handleError ));
  }
    
  handleError = (error) => {
    console.log("--handle error---",error)
    return throwError(error);
  }

  getGroupDevicesData(fan: any, sessionId: any){
    let url = this.utilityService.getEnvConfig().getGroupDevices+'?fan='+ fan + '&sessionId='+sessionId;
    return this.httpClientService.authorizedGet(url)
      .pipe(
        map((res: HttpResponse<any>) => {
          if (sessionStorage.getItem('sapmp_jwtToken') != null) {
            // refreshes token for logged in scenario upon page load
            this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
          }
        
        return res.body;
        }), 
        catchError(this.handleError));
  }

  updateGroupName(data: any){
    var url = this.utilityService.getEnvConfig().updateGroupName
    return this.httpClientService.post(url, data, this.get_headers())
    .pipe(
      map((test: HttpResponse<any>) => {
       if (sessionStorage.getItem('sapmp_jwtToken') != null) {
         // refreshes token for logged in scenario upon page load
         this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
       }
       return test.body;
     }),
      catchError( this.handleError ));
  }

  deleteGroup(data: any){
    var url = this.utilityService.getEnvConfig().deleteGroup;
    return this.httpClientService.post(url, data, this.get_headers())
    .pipe(
      map((test: HttpResponse<any>) => {
       if (sessionStorage.getItem('sapmp_jwtToken') != null) {
         // refreshes token for logged in scenario upon page load
         this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
       }
       return test.body;
     }),
      catchError( this.handleError ));
  }

}
